import moment, { Moment } from "moment-timezone";

export interface UserDates {
  joined?: Moment | Date | string | null;
  started?: Moment | Date | string | null;
  streakStart?: Moment | Date | string | null;
  lastTugged?: Moment | Date | string | null;
}

export interface UserBioData {
  dates: UserDates;
  streak?: number;
  bio?: string | null;
}

export default class UserCardUtils {
  /**
   * Build user bio text from user data
   * Combines joined date, started date, streak start, and bio into a formatted string
   * @param user - User object with dates, streak, and bio
   * @returns Formatted bio string
   */
  static buildBioText(user: UserBioData): string {
    const joined = user.dates.joined
      ? `Joined ${moment(user.dates.joined).format("MMM DD, YYYY")}`
      : null;
    const started = user.dates.started
      ? `Started ${moment(user.dates.started).format("MMM YYYY")}`
      : null;

    const bio = user.bio ? user.bio : null;

    // Build the text parts, preserving newlines in the bio
    const parts: string[] = [];
    if (started && user.dates.lastTugged) {
      parts.push(started);
    } else if (joined) {
      parts.push(joined);
    }
    if (bio) parts.push(bio);

    // Join with periods, but preserve any newlines within the bio
    return parts.join(". ");
  }

  /**
   * Build profile link URL
   * @param homepage - Base homepage URL
   * @param profileLink - User's profile link path
   * @returns Full profile URL
   */
  static buildProfileLink(homepage: string, profileLink: string): string {
    return `${homepage}${profileLink}`;
  }

  /**
   * Build navigation parameter for user profile
   * @param userName - User's name (optional)
   * @param uid - User's ID
   * @returns Navigation parameter string
   */
  static buildProfileParam(
    userName: string | null | undefined,
    uid: string
  ): string {
    return userName ? `user=${userName}` : `uid=${uid}`;
  }
}
